'use strict';
/*
* More Video Content Toggle
* @package krobot
* @deps jquery
*/
const $ = jQuery;

$( '.js-more-toggle' ).on( 'click keypress', function() {
	//toggle btn status
	$( this ).toggleClass( 'opened' );
	$( this ).find( '.more-text' ).toggleClass( 'active' );
	//more videos content toggle
	const targetVideos = $( this ).parents( '.js-more-btn' ).next( '.js-more-videos' );
	targetVideos.fadeToggle();
	return false;
} );
